import React, { Suspense, useMemo } from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

import ErrorBoundary from './ErrorBoundary';
import { MenuItem } from './config/interface';

function RouteList(props) {
  const { submenus } = props;

  const memoRenderRoutes = () => {
    // render routes
    const renderRoutes = (menus: Array<MenuItem>) => {
      if (!Array.isArray(menus) || menus.length === 0) return null;

      return menus.map((M) => {
        // recursive render children routes
        if (M.children && Array.isArray(M.children) && M.children.length > 0) {
          return renderRoutes(M.children);
        }

        return (
          <Route exact key={M.id} path={M.path}>
            <ErrorBoundary>
              <Suspense
                fallback={<Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />}
              >
                {M.component ? <M.component /> : null}
              </Suspense>
            </ErrorBoundary>
          </Route>
        );
      });
    };
    return renderRoutes(submenus);
  };

  const routes = useMemo(memoRenderRoutes, [submenus]);

  return routes;
}

const mapStateToProps = (state) => {
  const { submenus } = state.user;
  return { submenus };
};

export default connect(mapStateToProps, {})(RouteList);
